export const SELLING_TYPE_ISO_NONE = 0;
export const SELLING_TYPE_ISO_BUYER = 1;
export const SELLING_TYPE_ISO_SELLER = 2;
